import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

const containerStyle = css`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${theme.colors.neutral10};
  cursor: pointer;

  &:hover {
    background-color: ${theme.colors.neutral5};
  }

  .inner-container {
    padding: ${theme.spacing(2, 1.5)};
    border-left: 8px solid transparent;
  }
`;

interface GetListItemStyleConfig {
  isSelected: boolean;
}

export function getContainerStyle({ isSelected }: GetListItemStyleConfig) {
  if (isSelected) {
    return [
      containerStyle,
      css`
        background-color: ${theme.colors.neutral5};

        .inner-container {
          border-left-color: ${theme.colors.text.interactive};
        }
      `,
    ];
  }

  return containerStyle;
}

export const firstLineContainerStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
`;
